import {Endpoint} from '@eryxcoop/appyx-comm';

export default class DeleteOrdersArticleEndpoint extends Endpoint {

  adaptValues({orderNumber, articleCode}) {
    return {
      'order_number': orderNumber,
      'article_code': articleCode,
    }
  }

}